import React from "react";
import "./Styles/storefilter.css";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import searchicon from "../Images/Icones/searchicon.svg";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import storediv from "../Images/Icones/StoreDiv.svg";
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import RangeSlider from './RangeSlider';
import FilterLoader from "../Images/filter-loader.gif"
import { useEffect } from "react";

export default function StoreFilter({ subCategories, filterProducts, defaultRange, setPage, loading, queryCategory = null, querySearch = null }) {
    const [sort, setSort] = React.useState('recent');
    const [category, setCategory] = React.useState(0);
    const [rangePrice, setRangePrice] = React.useState({ min: 0, max: 0 });
    const [search, setSearch] = React.useState('');

    useEffect(()=>{
        setRangePrice(defaultRange)
    }, [defaultRange])
    useEffect(()=>{
        if(queryCategory !== null){
            setCategory(queryCategory);
        }

        if(querySearch !== null){
            setSearch(querySearch);
        }
    }, [queryCategory, querySearch])
    const changeSort = (event) => {
        setSort(event.target.value);
    };

    const changeCategory = (event) => {
        setCategory(event.target.value);
    };

    const handlePriceRange = (min, max) => {
        setRangePrice({ min: min, max: max })
    }

    const submitFilter = () => {
        filterProducts({
            order: sort,
            category: category,
            price: rangePrice,
            search: search
        })

        setPage(1)
    }

    return (
        <>
            <Card sx={{ maxWidth: 350, position: 'relative', backgroundColor: '#F5F5FF' }}>

                <CardContent sx={{ padding: '5px' }}>

                    <div className="store-search">
                        <span><img src={searchicon} alt="search" /></span>
                        <input value={search} name="search" placeholder="Entrez votre recherche" onChange={(e)=> setSearch(e.target.value)}  />
                    </div>
                    <div className="store-div">
                        <img src={storediv} alt="storediv" />
                    </div>
                    <p className="store-categorie">Trier Par</p>
                    <div className="store-select">
                        <FormControl sx={{ width: "90%" }} size="small">
                            <Select
                                value={sort}
                                className="input-filter-css"
                                label="Trier"
                                onChange={changeSort}
                                sx={{ '& legend': { display: 'none' }, '& fieldset': { display: 'none' } }}
                            >
                                <MenuItem value="recent">Récent</MenuItem>
                                <MenuItem value="name-asc">A-Z Croissant</MenuItem>
                                <MenuItem value="name-desc">A-Z Décroissant</MenuItem>
                                <MenuItem value="price-asc">Prix Croissant</MenuItem>
                                <MenuItem value="price-desc">Prix Décroissant</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="store-div">
                        <img src={storediv} alt="storediv" />
                    </div>
                    <p className="store-categorie">Catégories</p>
                    <div className="store-radio">
                        <FormControl sx={{ width: "90%" }} size="small">
                            <Select
                                value={category}
                                className="input-filter-css"
                                label="Categorie"
                                onChange={(e) => changeCategory(e)}
                                sx={{ '& legend': { display: 'none' }, '& fieldset': { display: 'none' }, }}
                            >
                                <MenuItem value={0}>Aucune</MenuItem>
                                {
                                    subCategories.map((x, index) => {
                                        return (
                                            <MenuItem key={'subCategoryMenuItem' + index} value={x.id}>{x.name}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                    </div>
                    <div className="store-div">
                        <img src={storediv} alt="storediv" />
                    </div>
                    <p className="store-categorie">Prix (XOF)</p>
                    <div className="store-slider">

                        <RangeSlider defaultRange={defaultRange} startValues={[rangePrice.min,rangePrice.max]} handlePriceRange={handlePriceRange} />
                        <Stack
                            component="form"
                            sx={{
                                width: '90%',
                            }}
                            spacing={2}
                            noValidate
                        >
                            <div className="store-textfield">

                                <div style={{marginRight: '10px'}}>
                                <TextField
                                    hiddenLabel
                                    variant="outlined"
                                    size="small"
                                    value={rangePrice.min}
                                />
                                </div>
                                <div>
                                <TextField
                                    hiddenLabel
                                    variant="outlined"
                                    size="small"
                                    value={rangePrice.max}
                                />
                                </div>
                            </div>
                        </Stack>
                    </div>
                    <div className="store-div">
                        <img src={storediv} alt="storediv" />
                    </div>
                    <button disabled={loading} onClick={() => submitFilter()} className="filter-btn"><span className="filter-btn-text">Appliquer</span> <span className="filter-btn-img"><img src={FilterLoader}/></span></button>
                </CardContent>

            </Card>

        </>
    )
}